import { User as UserIcon, LogOut } from "lucide-react";
import styles from "./UserMenu.module.css";

interface UserMenuProps {
  isLoggedIn: boolean;
  onLogout: () => void;
}

export const UserMenu = ({ isLoggedIn, onLogout }: UserMenuProps) => {
  if (!isLoggedIn) {
    return (
      <div className={styles.userMenuContainer}>
        <a href="/login" className={`btn-signup ${styles.navButton}`}>
          <UserIcon size={16} />
          <span>Log in</span>
        </a>
      </div>
    );
  }

  return (
    <div className={styles.userMenuContainer}>
      <a href="/dashboard" className={`btn-signup ${styles.navButton}`}>
        <UserIcon size={16} />
        <span>Dashboard</span>
      </a>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onLogout();
        }}
        className={`btn-signup ${styles.navButton}`}
      >
        <LogOut size={16} />
        <span>Logout</span>
      </a>
    </div>
  );
};

export default UserMenu;
